var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.commonModelShow)?_c('div',{staticClass:"model",style:(_vm.modelStyle)},[_c('div',{staticClass:"s-text",domProps:{"innerHTML":_vm._s(_vm.newText)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }